var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("招接待宾馆预约系统")]),
            _c("el-breadcrumb-item", [_vm._v("宾馆房间管理")]),
            _c("el-breadcrumb-item", [_vm._v("房间新增")]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "hx-form-container box-shadow" }, [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              attrs: { model: _vm.listParams, "label-width": "150px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间名称：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "small", placeholder: "房间名称" },
                    model: {
                      value: _vm.listParams.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "name", $$v)
                      },
                      expression: "listParams.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "房间类型：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "300px" },
                      attrs: {
                        clearable: "",
                        size: "small",
                        placeholder: "房间类型",
                      },
                      model: {
                        value: _vm.listParams.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "type", $$v)
                        },
                        expression: "listParams.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "普通间", value: "1" },
                      }),
                      _c("el-option", {
                        attrs: { label: "双人间", value: "2" },
                      }),
                      _c("el-option", {
                        attrs: { label: "三人间", value: "3" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "房间面积：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "small", placeholder: "请输入房间面积" },
                    model: {
                      value: _vm.listParams.area,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "area", $$v)
                      },
                      expression: "listParams.area",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "床型信息：" } },
                _vm._l(_vm.listParams.bed, function (bed, key, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "床型",
                          },
                          model: {
                            value: bed.size,
                            callback: function ($$v) {
                              _vm.$set(bed, "size", $$v)
                            },
                            expression: "bed.size",
                          },
                        },
                        _vm._l(_vm.bedSize, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.size, value: item.id },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100px" },
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "数量",
                          },
                          model: {
                            value: bed.num,
                            callback: function ($$v) {
                              _vm.$set(bed, "num", $$v)
                            },
                            expression: "bed.num",
                          },
                        },
                        _vm._l(_vm.bedNum, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.num, value: item.id },
                          })
                        }),
                        1
                      ),
                      key + 1 <= _vm.listParams.bed.length &&
                      _vm.listParams.bed.length !== 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "el-button el-button--primary el-button--small",
                              staticStyle: {
                                background: "rgb(139, 195, 74)",
                                border: "none",
                                "margin-left": "20px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.doDeleteBed(key)
                                },
                              },
                            },
                            [_c("span", [_vm._v("删除")])]
                          )
                        : _vm._e(),
                      _vm.listParams.bed.length === key + 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "el-button el-button--primary el-button--small",
                              staticStyle: {
                                background: "rgb(0, 150, 136)",
                                border: "none",
                                "margin-left": "20px",
                              },
                              attrs: { type: "button" },
                              on: { click: _vm.doAddBed },
                            },
                            [_c("span", [_vm._v("新增")])]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                "el-form-item",
                { attrs: { label: "房价(¥)：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { size: "small", placeholder: "填写金额" },
                    model: {
                      value: _vm.listParams.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "price", $$v)
                      },
                      expression: "listParams.price",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "宾馆图片：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "upload-thumbnail-img",
                    attrs: { loading: _vm.uploading },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline upload-icon",
                    }),
                    _c("input", {
                      staticClass: "hidden-upload",
                      attrs: {
                        type: "file",
                        accept: ".png,.jpg,.jpeg,.gif",
                        id: "uploadDom",
                      },
                      on: { change: _vm.doUpload },
                    }),
                  ]
                ),
                _vm.listParams.pictures.length > 0
                  ? _c(
                      "div",
                      { staticClass: "wrap-thumbnail-img" },
                      _vm._l(
                        _vm.listParams.pictures,
                        function (item, key, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "thumbnail-img" },
                            [
                              _c("div", { staticClass: "combined-img" }, [
                                _c("img", {
                                  key: index,
                                  staticClass: "thumbnail-img-wrapped",
                                  attrs: { src: item, alt: "" },
                                }),
                                _c("div", { staticClass: "hover-img" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-circle-close-outline close-btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteImg(key)
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "align-center",
                  staticStyle: {
                    "padding-bottom": "20px",
                    "margin-top": "30px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.isDisabled,
                        size: "small",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.saveAdd()
                        },
                      },
                    },
                    [_vm._v(" 保存 ")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.backToList } },
                    [_vm._v("返回")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }